module.exports = __webpack_public_path__ + "img/banner5.fe68d1f4.png";